import { FC, useEffect, useState } from "react";
import { useAlertsCountStore } from "../../../hooks/useSystemAlerts";
import TvChannels from "../../components/tvChannelMapping/TvChannels";
import SystemAlerts from "../../components/systemAlerts/SystemAlerts";
import Tabs, { TabElement, TabNavigation, TabNavigationElement, TabsContainer } from "../../components/tab/Tab";
import InnerLayout from "../innerLayout/InnerLayout";
import TvChannelsMapping from "../../components/tvChannelMapping/TvChannelsMapping";
import MediaTranscoding from "../../components/mediaTranscoding/MediaTranscoding";
import TagManagment from "../../components/tagManagment/TagManagment";


interface SettingsProps {
    logOut : () => void;
    toogleCollapse: () => void;
    isCollapsed: boolean;
}
 
type SettingsTab = "TVChannels" | "systemAlerts" | "TVMappingProfiles" | "MediaTranscodingProfiles" | "TagManagement";

const Settings: FC<SettingsProps> = (props: SettingsProps) => {
    let [activeTab, setActiveTab] = useState<SettingsTab>("systemAlerts");
    const checkActive = (tab: SettingsTab) =>  tab === activeTab;

    let {totalAlerts} = useAlertsCountStore();

    return ( <>
        <InnerLayout
            isCollapsed={props.isCollapsed}
            logOut={props.logOut}
            toogleCollapse={props.toogleCollapse}
            activeTab="settings"
            >
            <>
                <div style={{ paddingTop: '30px' }}>
                    <h2>Settings</h2>
                </div>
                <Tabs>
                    <TabNavigation>
                        <TabNavigationElement 
                            title="Alerts" 
                            tooltip={totalAlerts}
                            isActive={checkActive("systemAlerts")} 
                            onClick={() => { setActiveTab("systemAlerts") }} 
                        />
                        <TabNavigationElement 
                            title="TV Channels" 
                            isActive={checkActive("TVChannels")} 
                            onClick={() => { setActiveTab("TVChannels") }} 
                        />
                        <TabNavigationElement 
                            title="TV Mapping Profiles" 
                            isActive={checkActive("TVMappingProfiles")} 
                            onClick={() => { setActiveTab("TVMappingProfiles") }} 
                        />
                        <TabNavigationElement 
                            title="Media Transcoding Profiles" 
                            isActive={checkActive("MediaTranscodingProfiles")} 
                            onClick={() => { setActiveTab("MediaTranscodingProfiles") }} 
                        />
                        <TabNavigationElement 
                            title="Tag Management" 
                            isActive={checkActive("TagManagement")} 
                            onClick={() => { setActiveTab("TagManagement") }} 
                        />
                    </TabNavigation>
                    <TabsContainer>
                        <TabElement isActive={checkActive("systemAlerts")}>
                            <SystemAlerts />
                        </TabElement>
                        <TabElement isActive={checkActive("TVChannels")}>
                            <div className="w-100">
                            {checkActive("TVChannels") && <TvChannels />}
                            </div>
                        </TabElement>
                        <TabElement isActive={checkActive("TVMappingProfiles")}>
                            <div className="w-100">
                            {checkActive("TVMappingProfiles") && <TvChannelsMapping />}
                            </div>
                        </TabElement>
                        <TabElement isActive={checkActive("MediaTranscodingProfiles")}>
                            <div className="w-100">
                            {checkActive("MediaTranscodingProfiles") && <MediaTranscoding />}
                            </div>
                        </TabElement>
                        <TabElement isActive={checkActive("TagManagement")}>
                            <div className="w-100">
                            {checkActive("TagManagement") && <TagManagment />}
                            </div>
                        </TabElement>
                    </TabsContainer>
                </Tabs>
            </>
        </InnerLayout>
    </> );
}
 
export default Settings;
